module.exports = __webpack_public_path__ + "static/media/Kiosk-Americano-wht.a039023a.png";